const navbar = [
    {
        id: 1,
        mainLink: { link: '/', titleKey: 'navbar.home' },
        subLink: [],
    },
    {
        id: 2,
        mainLink: { link: '/O-nas', titleKey: 'navbar.about' },
        subLink: [
            { id: 1, link: '/O-nas', titleKey: 'navbar.about' },
            { id: 2, link: '/Poznaj-nas', titleKey: 'navbar.poznajnas' },
            { id: 3, link: '/RadaNaukowa', titleKey: 'navbar.scientificCouncil' },
            { id: 4, link: '/Historia', titleKey: 'navbar.history' },
            { id: 5, link: '/Legenda', titleKey: 'navbar.legend' },
            { id: 6, link: '/Drzewo-Pokolen', titleKey: 'navbar.generationTree' },
        ],
    },
    {
        id: 3,
        mainLink: { link: '/Muzeum', titleKey: 'navbar.museum' },
        subLink: [],
    },
    {
        id: 4,
        mainLink: { link: '/Uslugi', titleKey: 'navbar.offer' },
        subLink: [],
    },
    {
        id: 5,
        mainLink: { link: '/Szkolenie', titleKey: 'navbar.trainingProgram' },
        subLink: [],
    },
    {
        id: 6,
        mainLink: { link: '/Gadziak', titleKey: 'navbar.gadziak' },
        subLink: [],
    },
    {
        id: 7,
        mainLink: { link: '/Partnerzy', titleKey: 'navbar.partners' },
        subLink: [
            { id: 1, link: '/Partnerzy', titleKey: 'navbar.partners' },
            { id: 2, link: '/Partnerzy/Galeria', titleKey: 'navbar.gallery' },
        ],
    },
    {
        id: 8,
        mainLink: { link: '/Staze', titleKey: 'navbar.internships' },
        subLink: [
            { id: 1, link: '/Staze', titleKey: 'navbar.internships' },
            { id: 2, link: '/Staze/Formularz', titleKey: 'navbar.form' }, 
        ],
    },
    {
        id: 9,
        mainLink: { link: '/Psychologia-zieleni/Wywiad', titleKey: 'navbar.greenPsychology' },
        subLink: [
            { id: 1, link: '/Psychologia-zieleni/Wywiad', titleKey: 'navbar.psychologistInterview' },
            { id: 2, link: '/Psychologia-zieleni/Ogrodoterapia', titleKey: 'navbar.gardenTherapy' },
            { id: 3, link: '/Psychologia-zieleni/Sesje', titleKey: 'navbar.therapySessions' },
            { id: 4, link: '/Psychologia-zieleni/Joga', titleKey: 'navbar.yoga' },
        ],
    },
    {
        id: 10,
        mainLink: { link: '/Kolej-Waskotorowa', titleKey: 'navbar.narrowGaugeRailway' },
        subLink: [
            { id: 1, link: '/Kolej-Waskotorowa/Historia', titleKey: 'navbar.history' },
            { id: 2, link: '/Kolej-Waskotorowa/Towarzystwo', titleKey: 'navbar.railwaySociety' },
            { id: 3, link: '/Kolej-Waskotorowa/Galeria', titleKey: 'navbar.railwayGallery' },
        ],
    },
    {
        id: 11,
        mainLink: { link: '/Skontaktuj-sie', titleKey: 'navbar.contact' },
        subLink: [],
    },
];

export default navbar;